export default __webpack_public_path__ + "images/Imagen 4.9e8a34a9ab90baa170b0847b6911503d.png";